import { useMemo } from "react";

export default function useSortedItems(items, sortMode) {
    const sortedItems = useMemo(() => {
        if (!items) return [];

        const sorted = [ ... items]; // never mutate original
        
        switch (sortMode) {
            case "name":
                return sorted.sort((a, b) => a.name.localeCompare(b.name));

            case "name-reverse":
                return sorted.sort((a, b) => b.name.localeCompare(a.name));

            case "completed":
                return sorted.sort(
                    (a, b) => new Date(a.completedDate) - new Date(b.completedDate)
                );

            case "completed-reverse":
                return sorted.sort(
                    (a, b) => new Date(b.completedDate) - new Date(a.completedDate)
                );

            default: 
                return sorted;
        }
    }, [items, sortMode]);

    return sortedItems;
}